import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';

const lazyBootModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "NonBootConfigGql" */ './lazyIndex'),
    { name: 'NonBootConfigGql' }
);

export const lazyGetNonBootUserConfigurationViaGql: LazyAction<
    typeof lazyIndex.getNonBootUserConfigurationViaGql,
    typeof lazyBootModule
> = new LazyAction(lazyBootModule, m => m.getNonBootUserConfigurationViaGql);
